const sv = {
  common: {
    loading: "Belastning...",
    close: "Nära",
    submit: "Överlämna",
    review: "Recension",
    help: "Hjälp",
    tour: "Tur",
    instructions: "Instruktioner",
    language: "Språk",
    ok: "Ok",
    appLoaderText:
      "Laddar... Vänligen vänta medan vi förbereder din bedömningsmiljö."
  },
  assessment: {
    fetchError: "Fel vid hämtning av {{featureName}}",
    somethingWentWrong: "Något gick fel.",
    goBackToDashboard: "Gå tillbaka till instrumentpanelen",
    confirmSubmissionTitle: "Bekräfta inlämning",
    scheduleIdNotFound: "Schema-ID hittades inte",
    ongoingIdNotFound: "Pågående ID hittades inte",
    errorFetchingOngoingData: "Fel vid hämtning av pågående data",
    connectionRestoredLabel: "Anslutningen återställd.",
    connectionRestoredDescription: "Du kan fortsätta köra testfall.",
    connectionLostLabel: "Vi har tappat anslutningen till testservern.",
    connectionLostDescription:
      "Du kommer inte att kunna köra eller validera testfall just nu.",
    featureNames: {
      assessment: "Bedömning",
      knowledgeCheck: "Kunskapskontroll"
    },
    cardStatus: {
      na: "Ej tillämpligt",
      toBeLaunched: "Inte startad ännu",
      expired: "Utgått",
      expiringSoon: "Upphör snart",
      ongoing: "Pågår"
    },
    cardState: {
      draft: "Utkast",
      published: "Publicerad",
      cancelled: "Avbruten",
      inreview: "Under granskning",
      readytopublish: "Klar för publicering",
      sentback: "Tillbakaskickad"
    },
    dashboard: {
      videoProctoring: "Video Proctoring",
      submitFeature: "Skicka {{featureName}}",
      noSectionsFound: "Inga avsnitt hittades",
      expandAllSections: "Expandera alla avsnitt",
      closeAllSections: "Stäng alla sektioner",
      continueShapingAssessments: "Fortsätt forma dina bedömningar",
      viewAll: "Visa alla",
      legend: {
        notStarted: "Inte startat",
        inProgress: "Pågår",
        completed: "Avslutad"
      }
    },
    confirmModal: {
      description:
        "När du väl har skickat in kommer du inte att kunna göra några ändringar i din {{featureName}}. Granska dina svar innan du bekräftar. Vill du fortsätta med inlämningen?",
      lowWordCountWarning:
        "Ditt svar på frågan, {{questionTitle}}, är mindre än 40 ord. Om du skickar in bedömningen nu kommer detta svar inte att sparas.",
      videoNotSubmittedWarning:
        "Din inspelade video för frågan {{questionTitle}} har inte skickats in. Om du skickar in bedömningen nu förkastas detta svar.",
      unansweredQuestions: "Du har {{count}} obesvarade frågor",
      andFlaggedQuestions: "och {{count}} flaggade frågor",
      failedToFinish: "Det gick inte att slutföra {{featureName}}"
    },
    feedback: {
      submittedTitle: "Din {{featureName}} har skickats!",
      submittedDescription:
        "Dina svar har skickats. Vi uppskattar tiden och ansträngningen du har lagt ner på att slutföra denna {{featureName}}!",
      resultInProgress:
        "Resultatet beräknas och det kan ta upp till en minut. Vänligen vänta...",
      resultReady:
        "Resultatet är klart! Klicka på knappen Visa resultat för att se det.",
      resultDelayed:
        "Resultatberäkningen tar längre tid än vanligt. Kontakta administratören för ditt resultat.",
      showResult: "Visa resultat",
      redirectingToResult:
        "Omdirigerar till resultatsidan på {{seconds}} sekunder om du inte klickar på knappen Visa resultat",
      shareFeedbackTitle: "Dela din feedback",
      shareFeedbackDescription:
        "Dina insikter banar väg för tillväxt. Låt oss gå upp i nivå tillsammans!",
      errorSubmittingFeedback: "Det gick inte att skicka feedback",
      feedbackSubmittedTitle: "Allt klart, feedback har skickats!",
      feedbackSubmittedDescription:
        "Din feedback har skickats. Tack för att du hjälper oss att förbättra upplevelsen av {{featureName}}!",
      feedbackAlreadySubmittedTitle: "Allt klart, feedback har redan skickats!",
      feedbackAlreadySubmittedDescription:
        "Det verkar som att du redan har skickat feedbacken. Tack för att du hjälper oss att förbättra upplevelsen av {{featureName}}!"
    },
    page: {
      errorFetchingPreAssessmentData: "Fel vid hämtning av förutvärderingsdata",
      connectionRestoredLabel: "Anslutningen återställd.",
      connectionRestoredDescription: "Synkroniserar dina senaste ändringar...",
      offlineLabel: "Du verkar vara offline.",
      offlineDescription: "Ändringar synkroniseras inte förrän du återansluter"
    },
    question: {
      questions: "Frågor",
      closeQuestionsPanel: "Stäng frågepanelen",
      collapse: "Kollapsa",
      sectionSummary: "Sektionssammanfattning",
      sections: "Avsnitt",
      toggleQuestionsPanel: "Växla frågepanelen",
      switchModal: {
        switchQuestionButton: "Byt fråga",
        leaveHeading: "Är du säker på att du vill lämna?",
        discardMessage:
          "Du har osparade ändringar. Om du ändrar frågan kommer ditt svar att raderas permanent.",
        saveChangesButton: "Spara ändringar",
        saveHeading: "Vill du spara ändringarna?",
        saveBeforeSwitchMessage:
          "Du har osparade ändringar. Vill du spara dem innan du ändrar frågan?"
      }
    },
    faq: {
      q1: {
        question: "Vad ska jag göra innan jag startar {{featureName}}?",
        firstSentence: "Se till att du har slutfört följande:",
        list: {
          item1: "En stabil internetuppkoppling",
          item2:
            "En fungerande webbkamera och mikrofon (om videoproctoring är aktiverad)",
          item3: "En tyst, distraktionsfri miljö",
          item4:
            "Om videoproctoring är aktiverat kommer du att bli ombedd att slutföra en systemkontroll.",
          item5: "Läs och godkänn användarvillkoren"
        }
      },
      q2: {
        question:
          "Kan jag navigera mellan frågor eller avsnitt under {{featureName}}?",
        firstSentence: "Navigeringen beror på inställningarna.",
        list: {
          item1:
            "Om avsnittsnavigering är aktiverat kan du flytta mellan avsnitt.",
          item2:
            "Om det är inaktiverat måste du slutföra ett avsnitt innan du går vidare till nästa."
        },
        lastSentence:
          "Instruktioner kommer att finnas tillgängliga hela tiden under {{featureName}}."
      },
      q3: {
        question: "Kommer jag att övervakas under testet?",
        list: {
          item1:
            "Om denna {{featureName}} har videoproctoring aktiverad kommer din kamera och mikrofon att användas.",
          item2: "All ovanlig aktivitet kan flaggas för granskning."
        }
      },
      q4: {
        question:
          "Vad händer om jag tappar internetanslutningen eller stänger webbläsaren av misstag?",
        firstSentence: "Dina framsteg sparas automatiskt.",
        lastSentence:
          "Om frånkoppling inträffar kan du gå med i {{featureName}} igen med samma länk."
      },
      q5: {
        question:
          "Kommer jag att få se mina resultat eller feedback efter testet?",
        firstSentence:
          "Resultat och feedback konfigureras av {{featureName}}-arrangören.",
        list: {
          item1:
            "Om det är aktiverat ser du din poäng och feedbacksammanfattning efter inlämning.",
          item2:
            "Om inte kommer dina resultat att delas via din registrerade e-post."
        }
      }
    },
    labels: {
      totalDuration: "Total varaktighet",
      numberOfQuestions: "Antal frågor",
      numberOfSections: "Antal sektioner",
      guidelines: "Riktlinjer",
      platformHelp: "Plattformshjälp",
      faq: "FAQ",
      frequentlyAskedQuestions: "Vanliga frågor",
      showFeatureInstructions: "Visa {{featureName}} instruktioner",
      minutes: "minuter",
      welcome: "Välkomna",
      welcomeBack: "Välkommen tillbaka",
      userFallback: "Användare",
      defaultGuidelines:
        "Innan du startar {{featureName}}, se till att du befinner dig i ett tyst, distraktionsfritt utrymme med en stabil internetanslutning. Håll kameran på under hela testet och hantera din tid klokt eftersom det finns en tidsgräns. Om du stöter på några tekniska problem, kontakta supporten omedelbart. När du är klar, granska dina svar innan du skickar in. Lycka till!"
    },
    zoom: {
      textSize: "Textstorlek:",
      decreaseTextSize: "Minska textstorleken (A-)",
      resetTextSize: "Återställ textstorlek (A)",
      increaseTextSize: "Öka textstorleken (A+)",
      decreaseInterfaceSize: "Minska gränssnittsstorleken",
      resetInterfaceSize: "Återställ gränssnittsstorlek",
      increaseInterfaceSize: "Öka gränssnittsstorleken"
    },
    wrapper: {
      warningTitle: "Varning!",
      stayOnPageMessage:
        "Vänligen stanna kvar på den här sidan tills du slutför {{featureName}}.",
      iUnderstand: "Jag förstår",
      submitTheFeature: "Skicka in {{featureName}}",
      videoProctoringInterrupted: "Video Proctoring avbruten",
      continuationBlocked:
        "Fortsättning av bedömningen är blockerad tills säker videoproctoring återställs.",
      retryProctoring: "Försök Proctoring igen"
    },
    progress: {
      proceed: "Fortsätta",
      resumeFeature: "Återuppta {{featureName}}",
      timeRemainingMessage:
        "kvar i {{featureName}}. Klicka nedan för att fortsätta där du slutade.",
      continueOnThisDevice: "Vill du fortsätta på den här enheten?",
      switchToThisTab: "Byta till den här fliken?",
      continueYourAssessmentHere: "Fortsätt din bedömning här?",
      switchHere: "Byt här",
      attemptsUnlimited:
        "Du har obegränsade försök tillgängliga för denna bedömning.",
      attemptsSingle:
        "Du har <strong>1</strong> försök tillgängligt för denna bedömning.",
      attemptsMultiple:
        "Du har <strong>{{remainingAttempts}}</strong> av <strong>{{maxAttempts}}</strong> försök tillgängliga för denna bedömning.",
      coolOffAfterAttempt:
        "Efter varje försök måste du vänta <strong>{{coolOffTime}}</strong> innan du påbörjar ditt nästa försök."
    },
    loginWindow: {
      expiredTitle: "Inloggningstiden har gått ut",
      expiredMessage:
        "Inloggningsfönstret för denna {{featureName}} är nu stängt. Du missade den tillåtna tiden för att komma åt testet."
    },
    coding: {
      saving: "Sparande",
      offlineTitle: "Det verkar som att du är offline",
      offlineDescription: "Ändringar synkroniseras inte förrän du återansluter",
      connectionRestored: "Anslutningen återställd",
      syncingLatest: "Synkroniserar dina senaste ändringar...",
      autoSaveEnabled: "Autospara är aktiverat",
      runOnlyChecksDescription: "kontrollerar bara din kod mot testfall.",
      submitEvaluationDescription:
        "din kod för att få den utvärderad och få poäng.",
      reset: "Återställ",
      run: "Kör",
      runTests: "Löpande tester",
      submit: "Överlämna",
      submitting: "Skickar in",
      resetCode: "Återställ koden",
      resetCodeMessage:
        "Är du säker på att du vill återställa? Detta tar bort all din nuvarande kod och återställer startkoden",
      testCases: "Testfall",
      testCase: "Testfall {{index}}",
      testCasePassed: "Testfall godkänt",
      testCaseFailed: "Testfall misslyckades",
      runtimeError: "Runtime Error",
      timeLimitExceeded: "Tidsgränsen har överskridits",
      timeLimitExceededTitle: "Tidsgränsen har överskridits",
      timeLimitExceededDescription:
        "Din kod kördes inte inom tidsgränserna. Vänligen optimera din kod.",
      input: "Input",
      expectedOutput: "Förväntad utgång",
      yourOutput: "Din produktion",
      hiddenTestCase: "Dolt testfall",
      hiddenTestCaseDescription:
        "Dolda testfall används för att utvärdera om din kod kan hantera olika scenarier inklusive hörnfall",
      explanation: "Förklaring",
      hints: "Tips"
    },
    subjective: {
      minWordsRequired: "Minst 40 ord krävs för att skicka in svaret.",
      enterYourAnswer: "Ange ditt svar",
      submitResponse: "Skicka svar",
      submittingResponse: "Skickar svar...",
      resetAnswer: "Återställ svar",
      resetAnswerMessage:
        "Är du säker på att du vill återställa? Ditt nuvarande svar kommer att tas bort permanent.",
      retake: "Ta om",
      showHint: "Visa tips",
      recording: "INSPELNING"
    },
    systemCheck: {
      calibrate: "Kalibrera",
      calibrating: "Kalibrerar...",
      accessDenied: "Åtkomst nekad",
      cameraPermissionDenied:
        "Tillstånd nekad för kamera. Aktivera kameraåtkomst i webbläsarinställningarna för att fortsätta.",
      errorFetchingDevices: "Det gick inte att hämta enheter",
      failedToStartAssessment: "Det gick inte att starta bedömningen",
      unableToStartSecureProctoring:
        "Det går inte att starta säker proctoring just nu. Försök igen.",
      unnamedCamera: "Namnlös kamera",
      facingCalibrationIssues: "Står du inför problem med videokalibrering?",
      lookAtCenter: "Titta i mitten av skärmen och förbli stilla.",
      unableToCalibrateTitle:
        "Kan du inte kalibrera din kamera för videoproctoring?",
      statusMessages: {
        readyForCalibration:
          'Se till att ditt ansikte är väl synligt och centrerat på skärmen. När du är klar klickar du på "Kalibrera" för att börja.',
        calibratingInProgress: "Kalibrering pågår. Fortsätt titta på skärmen.",
        calibratingTimedOut:
          "Kamerakalibrering tog timeout. Uppdatera din webbläsare för att fortsätta.",
        preparingCameraPreview:
          "Förbereder kameraström och ansiktsspårning för kalibrering.",
        retryRequired:
          "Proctoring-installationen kräver din åtgärd innan du fortsätter.",
        proctoringUnavailable:
          "Proctoring är för närvarande inte tillgänglig och bedömningen kan inte starta säkert.",
        calibrationCompleted:
          "Kalibrering lyckad! Du är redo att påbörja bedömningen.",
        timeoutHelp:
          "Om du fortfarande ser det här meddelandet, leta efter andra flikar/appar som använder kameran eller en extern slutare."
      },
      failureReasons: {
        cameraPermissionDenied:
          "Kamerabehörighet är blockerad. Tillåt åtkomst och försök igen.",
        cameraUnavailable:
          "Kameran är inte tillgänglig. Kontrollera ditt val av enhet och försök igen.",
        facemeshInitFailed:
          "Ansiktsspårning misslyckades. Försök igen för att fortsätta.",
        cocoLoadFailed:
          "Proctoring-motorn är inte tillgänglig. Uppdatera och försök igen.",
        streamLostReacquireFailed:
          "Återställning av kameraström misslyckades. Försök proctoring igen.",
        calibrationInsufficientData:
          "Kalibreringsprover var otillräckliga. Försök att kalibrera igen.",
        detectionCadenceUnavailable:
          "Tidskonfigurationen är inte klar. Försök igen snart."
      },
      calibrationInfo: {
        heading: "För att lyckas kalibrera din video, följ dessa steg:",
        followUpHeading:
          "Följ dessa steg om du fortfarande stöter på problemet:",
        initialSteps: {
          step1: {
            title: "Säkerställ bra belysning",
            description:
              "Sitt i ett väl upplyst område med ditt ansikte väl synligt. Undvik starkt ljus eller fönster bakom dig."
          },
          step2: {
            title: "Vänd dig rakt mot kameran",
            description:
              "Placera ditt ansikte i mitten av ramen och titta rakt in i kameran under kalibreringen."
          },
          step3: {
            title: "Undvik mörka eller suddiga bakgrunder",
            description: "Se till att din bakgrund är tydlig och inte för mörk."
          },
          step4: {
            title: "Kontrollera kamerabehörigheter",
            description:
              "Tillåt din webbläsare att komma åt webbkameran när du uppmanas."
          },
          step5: {
            title: "Håll dig stilla och titta på skärmen",
            description:
              "Håll huvudet stadigt under kalibreringen för att hjälpa systemet att upptäcka ditt ansikte korrekt."
          }
        },
        laterSteps: {
          step1: "Testa att uppdatera sidan och kalibrera om kameran.",
          step2: "Stäng andra appar med webbkameran (som Zoom eller Teams).",
          step3:
            "Om problemet fortsätter kontakta {{contactEmail}} med en skärmdump av felet."
        }
      }
    },
    stepper: {
      termsAndConditions: "Regler och villkor",
      agreeTerms: "Jag har läst och godkänner villkoren.",
      previousStep: "Föregående steg",
      nextStep: "Nästa steg",
      startAssessment: "Starta bedömning",
      resumeAssessment: "Återuppta bedömning",
      mediaCheck: "Mediekontroll",
      systemCheck: "Systemkontroll",
      audioCheck: {
        intro:
          "Du kan spela in en kort video här för att kontrollera att kameran och mikrofonen fungerar som de ska.",
        mediaPermissionDenied:
          "Åtkomst till kamera eller mikrofon nekades. Aktivera behörigheter i webbläsarens inställningar.",
        startRecording: "Starta inspelning",
        stopRecording: "Stoppa inspelning",
        unnamedMicrophone: "Namnlös mikrofon"
      },
      stepLabel: "STEG {{step}}",
      personalDetails: "Personliga detaljer",
      emailId: "E-post-ID",
      firstName: "Förnamn",
      lastName: "Efternamn",
      defaultTncStatement:
        "Genom att delta i denna bedömning bekräftar du att du uppfyller behörighetskraven som specificerats av företaget och samtycker till att genomföra testet självständigt, utan extern hjälp. Bedömningen är föremål för videoproctoring, och du måste ha din kamera påslagen under hela sessionen i en distraktionsfri miljö. Allt innehåll och material som tillhandahålls under bedömningen är konfidentiellt och får inte delas, reproduceras eller distribueras. Du samtycker till att följa den angivna tidsgränsen för bedömningen; underlåtenhet att lämna in innan deadline kan leda till diskvalificering. Företaget ansvarar inte för några tekniska problem relaterade till din internetanslutning, mjukvara eller hårdvara. Personuppgifter som samlas in under bedömningen kommer endast att behandlas i utvärderings- och rekryteringssyfte, i enlighet med företagets integritetspolicy. Varje försök att fuska, plagiera eller på annat sätt ägna sig åt oetiskt beteende kommer att leda till omedelbar diskvalificering. Genom att skicka in dina svar bekräftar du att de är slutgiltiga, och inga ändringar kan göras efter inlämnandet. Företaget förbehåller sig rätten att ändra eller uppdatera dessa villkor när som helst och deltagarna kommer att meddelas om alla väsentliga ändringar.",
      okay: "Okej"
    },
    access: {
      cancelledTitle: '"{{title}}" har avbrutits',
      cancelledDescription:
        "Denna bedömning är inte längre aktiv och kan inte nås. Granska din instrumentpanel för andra tilldelade eller kommande bedömningar.",
      goToHome: "Gå till Hem",
      refreshPage: "Uppdatera sidan"
    },
    errorPage: {
      goBack: "Gå tillbaka",
      raiseRequest: "Skicka förfrågan",
      retryLogin: "Försök logga in igen",
      contactUs: "Kontakta oss",
      goBackToEvent: "Tillbaka till evenemang",
      launchCourse: "Starta kurs",
      created: "Skapad",
      starts: "Startar",
      ends: "Slutar",
      untitled: "Namnlös"
    },
    sidebar: {
      home: "Hem",
      quickAccess: "Snabbåtkomst",
      questionPaperAuthoring: "Frågeförfattande",
      assessmentLibrary: "Bedömningsbibliotek",
      scheduleInterview: "Schemalägg intervju",
      generateQuestions: "Generera frågor",
      roleManagement: "Rollhantering",
      logout: "Logga ut",
      noAccess: "Ingen åtkomst",
      noAccessWithLabel: "{{label}} (Ingen åtkomst)",
      noAccessToLink: "Du har inte åtkomst till den här länken",
      expandSidebar: "Expandera sidopanel",
      collapseSidebar: "Kollapsa sidopanel",
      expand: "Expandera",
      collapse: "Kollapsa",
      myPreferences: "Mina inställningar"
    },
    timesUp: {
      title: "Bedömningstid slutförd",
      autoSubmittedMessage:
        "Timern har gått ut. Dina svar har sparats och {{featureName}} har skickats in automatiskt."
    },
    resultCard: {
      title: "{{featureName}} Resultat",
      score: "Göra",
      passPercentage: "Godkänd procent",
      marksAway:
        "Du är {{count}} poäng borta från certifiering. Fokusera på de rekommenderade områdena och försök igen.",
      certificationEarned:
        "Du överträffade certifieringskraven och fick din certifiering",
      congratulationsOnEarning:
        "Grattis till att du har fått {{featureName}}-certifieringen",
      almostThereTitle: "Du är närmare än du tror att få certifieringen",
      certificatePassedDescription:
        "Du har visat de kunskaper och färdigheter som krävs för att uppnå denna certifiering. Ta en stund för att fira denna prestation och dela den med ditt nätverk",
      certificateFailDescription:
        "Detta försök visade på möjligheter att stärka dina färdigheter. Granska de rekommenderade områdena och återvänd med tillförsikt",
      congratsImageAlt: "Grattis bild",
      almostThereImageAlt: "Nästan där Bild"
    },
    sectionCard: {
      section: "Avsnitt",
      startSection: "Startsektion",
      continueSection: "Fortsätt avsnitt",
      completed: "Avslutad",
      viewSection: "Visa avsnitt",
      totalQuestions: "Totalt antal frågor:",
      sectionNotFound: "Avsnittet hittades inte.",
      total: "Total",
      flagged: "Flaggat"
    },
    sectionSummary: {
      totalQuestions: "Totalt antal frågor",
      completedQuestions: "Avslutade frågor",
      flaggedQuestions: "Flaggade frågor",
      unattemptedQuestions: "Oförsökta frågor",
      codingQuestions: "Kodningsfrågor:",
      objectiveQuestions: "Objektiva frågor:",
      goToSections: "Gå till avsnitt",
      lowWordCountWarning:
        "Ditt svar på frågan, {{questionTitle}}, är mindre än 40 ord. Om du går tillbaka till avsnittslistan kommer detta svar att kasseras.",
      videoNotSubmittedWarning:
        "Din inspelade video för frågan {{questionTitle}} har inte skickats in. Om du går tillbaka till avsnittslistan kommer detta svar att kasseras."
    },
    objective: {
      questionCounter: "Fråga",
      marks: "Märken:",
      explanation: "Förklaring",
      hints: "Tips",
      reset: "Återställ",
      flag: "Flagga",
      unflag: "Ta bort flaggan",
      previous: "Tidigare",
      saveAndNext: "Spara & Nästa",
      saveAndViewSummary: "Spara och visa avsnittssammanfattning",
      next: "Nästa",
      viewSectionSummary: "Visa avsnittssammanfattning",
      hideExplanation: "Dölj förklaring",
      showExplanation: "Visa förklaring",
      hintWaitTooltip: "Du måste vänta innan du ser ett annat tips",
      noHintsPendingTooltip: "Inga tips väntar",
      selectOptionForExplanation:
        "Välj alternativ för att se förklaringen av det valda alternativet"
    },
    tour: {
      shared: {
        timer:
          "Denna timer visar den återstående tiden för din bedömning. Vänligen övervaka det noga för att säkerställa att du slutför alla avsnitt inom den tilldelade tiden.",
        submit:
          "När du har slutfört alla delar av bedömningen kan du skicka in ditt arbete genom att klicka på knappen 'Skicka bedömning'. Den här åtgärden slutför dina svar och du kommer inte längre att kunna göra ändringar när du väl har skickat in. Se till att du har granskat alla dina svar innan du fortsätter med inlämningen."
      },
      dashboard: {
        legend:
          "Sektionsstatusförklaringen hjälper dig att förstå dina framsteg under bedömningen. Den använder tydliga indikatorer för att visa om ett avsnitt inte har påbörjats, pågår för närvarande eller har slutförts. Detta gör att du snabbt kan bedöma vilka delar som fortfarande kräver din uppmärksamhet och hantera din tid effektivt.",
        sectionCard:
          "Sektionskortet ger en detaljerad översikt över varje bedömningsavsnitt. Den visar avsnittets titel, dess aktuella status och nyckelinformation om frågorna inom avsnittet. Detta inkluderar det totala antalet frågor, antalet flaggade frågor och antalet frågor som har slutförts. Sektionskortet hjälper dig att övervaka dina framsteg och identifiera områden som kan behöva mer uppmärksamhet."
      },
      coding: {
        titles:
          "Överst på sidan hittar du en tydlig visning av bedömningstiteln och avsnittstiteln. Detta hjälper dig att hålla reda på din nuvarande uppgift och säkerställer att du är medveten om det specifika avsnittet du arbetar med. Se dessa titlar för att hålla dig orienterad när du navigerar genom frågorna.",
        sectionsButton:
          "Den här knappen låter dig enkelt navigera tillbaka till sektionernas instrumentpanel. Använd den för att återgå till huvudöversikten av din bedömning, där du kan se och hantera framstegen för alla avsnitt. Det ger ett snabbt sätt att omvärdera dina övergripande framsteg utan att förlora något av ditt nuvarande arbete.",
        sidebar:
          "Sidofältet ger en översikt över alla frågor inom det aktuella avsnittet du försöker. Det låter dig snabbt navigera mellan frågorna genom att helt enkelt välja det relevanta blocket. Varje frågeblock är färgkodat baserat på dess status, vilket gör det enkelt att spåra dina framsteg och hoppa till specifika frågor efter behov.",
        questionCard:
          "Det här kortet innehåller frågan du för närvarande arbetar med, visar hela uppmaningen och eventuella relevanta instruktioner eller inmatningskrav. Den är utformad för att ge dig en tydlig bild av uppgiften, med all nödvändig information för att fortsätta. Du hittar också en knapp för att flagga frågan för senare granskning, så att du enkelt kan besöka den igen om det behövs. Dessutom finns det navigeringsknappar som låter dig gå till nästa eller föregående fråga utan att gå tillbaka till sidofältet, vilket säkerställer smidig och effektiv progression genom bedömningen.",
        editor:
          "Kodredigeraren är där du kommer att skriva och ändra dina lösningar. Du kan växla mellan olika programmeringsspråk för att matcha kraven för varje fråga. Dessutom har du möjlighet att justera redigerarens tema för en bekvämare kodningsupplevelse. Om du föredrar mer skärmutrymme kan editorn utökas till full bredd, vilket ger dig ett större område att arbeta med. Dessa funktioner är utformade för att ge en flexibel och användarvänlig miljö när du slutför dina kodningsuppgifter."
      }
    },
    toast: {
      proctoringViolationDetected: "Proctoring överträdelse upptäckt",
      messages: {
        forbiddenObjectDetected: "Förbjudet objekt upptäckt",
        noFaceDetected: "Inget ansikte upptäckt",
        multipleFacesDetected: "Flera ansikten har upptäckts",
        lookingAwayFromScreen: "Tittar bort från skärmen",
        notLookingAtScreen: "Tittar inte på skärmen",
        faceNotOrientedCorrectly: "Ansiktet är inte rätt orienterat",
        eyesNotFullyOpen: "Ögonen inte helt öppna",
        copyNotAllowed: "Kopiering är inte tillåtet",
        cutRestricted: "Skärning är begränsad i proctoring-läge",
        pasteNotAllowed: "Klistra in är inte tillåtet",
        contextMenuNotAllowed: "Det är inte tillåtet att öppna snabbmenyn"
      }
    },
    whatsNext: {
      heading: "Vad är nästa?",
      attemptsRemaining: "försök kvar",
      passed: {
        shareLinkedInTitle: "Dela på LinkedIn",
        shareLinkedInSubtitle:
          "Fira din prestation med ditt professionella nätverk.",
        viewCertificateTitle: "Visa certifikat",
        viewCertificateSubtitle:
          "Ladda ner eller få tillgång till din certifiering när som helst.",
        shareGloTitle: "Dela erfarenhet",
        shareGloSubtitle:
          "Inspirera kollegor genom att publicera din prestation internt."
      },
      failed: {
        reviewLearningResourcesTitle: "Granska läranderesurser",
        reviewLearningResourcesSubtitle:
          "Stärk den färdighet som behöver uppmärksamhet.",
        retakeAssessmentTitle: "Gör om bedömningen",
        retakeAssessmentSubtitle:
          "Visa dina framsteg och uppdaterad förståelse."
      },
      modal: {
        title: "Dela prestation",
        linkedInPostLabel: "Dela på LinkedIn som inlägg",
        linkedInProfileLabel: "Lägg till som certifiering i LinkedIn-profilen",
        gloLabel: "Dela på Glo",
        comingSoon: "Kommer snart",
        infoMessage: "Du måste vara inloggad på plattformen för att dela."
      }
    },
    time: {
      hour_one: "{{count}} timme",
      hour_other: "{{count}} timmar",
      minute_one: "{{count}} minut",
      minute_other: "{{count}} minuter",
      hourShort: "h",
      minuteShort: "min",
      secondShort: "s"
    },
    accessScreens: {
      attemptResultProcessing: {
        alt: "{{featureName}} resultat bearbetas",
        title: "Dina resultat bearbetas",
        description:
          "Vi granskar fortfarande din {{featureName}}. Kom tillbaka snart!"
      },
      coolOffPeriod: {
        alt: "Avkylningsperiod",
        title: "Nästa försök tillgängligt snart",
        completedAttempt: "Du har redan gjort ett försök för detta",
        nextAttemptIntro: ". Ditt nästa försök kommer att vara tillgängligt om"
      },
      maxAttemptExceeded: {
        alt: "Maximalt antal försök har uppnåtts",
        title: "Maximalt antal försök har uppnåtts",
        description:
          "Du har använt alla tillgängliga försök för denna {{featureName}}. Inga ytterligare försök kan göras."
      },
      scheduleNotStarted: {
        alt: "Schema har inte startat",
        title: "{{featureName}} Inte startat än",
        scheduledPrefix: "De",
        scheduledOn: "är planerad att börja den",
        checkBack: "Kom tillbaka i {{time}} eller uppdatera när tiden börjar."
      },
      scheduleTimeCompleted: {
        alt: "Schemalagd tid klar",
        title: "{{featureName}} Fönster stängt",
        description:
          "Den schemalagda tiden för denna {{featureName}} har passerat. Du kan inte längre starta eller skicka in ett försök."
      }
    },
    attemptDetails: {
      allAttempts: "Alla försök",
      headers: {
        attempt: "Försök",
        attemptedOn: "Försökte på",
        percentage: "Procentsats"
      },
      viewAllAttempts: "Visa alla försök"
    },
    survey: {
      questions: {
        q1: "På en skala från 1 till 5, hur tydligt hittade du frågorna {{featureName}}?",
        q2: "Jag kände mig tillräckligt förberedd för de ämnen som diskuterades i {{featureName}}",
        q3: "Plattformen som användes för {{featureName}} var användarvänlig och funktionell",
        q4: "Jag tror att mina svar effektivt visade upp mina färdigheter och kunskaper"
      },
      stronglyDisagree: "Håller inte med starkt",
      stronglyAgree: "Håller starkt med",
      submitFeedback: "Skicka feedback"
    },
    cameraPreview: {
      loadingAlt: "Förhandsvisning av kamera laddas",
      delayedMessage:
        "Kalibreringen tar längre tid än förväntat på grund av ett långsamt nätverk. Vänta eller försök uppdatera sidan."
    },
    proctoring: {
      engineLoadFailedStatus: "Proctoringmotorn kunde inte laddas",
      runtimeErrors: {
        cameraPermissionDenied:
          "Kameraåtkomst blockeras av webbläsarens behörighetsinställningar.",
        cameraUnavailable:
          "Kameran är inte tillgänglig eller används för närvarande av ett annat program.",
        unableToLoadModel:
          "Det gick inte att ladda proctoring-objektdetekteringsmodell.",
        webglRecoveryFailed:
          "WebGL-återställning misslyckades vid återställning av objektdetektering."
      },
      logs: {
        engineLoadFailed: "ProctoringEngine kunde inte ladda:",
        videoPlayRejected: "Video play() avvisades:",
        cameraTrackEnded: "Kameraspår har avslutats – försök att återhämta",
        cameraReacquired: "Kameran återköptes vid försök {{attempt}}",
        cameraReacquireAttemptFailed:
          "Försök att återhämta kameran {{attempt}} misslyckades:",
        cameraReacquireFailedAll:
          "Kameraåterhämtning misslyckades efter alla försök - rapporterar kameran frånkopplad varje cykel",
        uploadFailedQueued:
          "Proctoring uppladdning misslyckades efter {{attempts}} försök, köade för ett nytt försök:",
        uploadAttemptFailedRetrying:
          "Proctoring uppladdningsförsök {{attempt}} misslyckades, försöker igen...",
        drainedQueuedViolation:
          "Dränerad kööverträdelse: {{violationType}} ({{remaining}} återstår)",
        queueDrainFailed:
          "Ködräneringen misslyckades, kommer att försöka igen nästa cykel:",
        cocoLoadFailed: "COCO-SSD-laddning misslyckades:",
        faceProcessingError: "Ansiktsbehandlingsfel:",
        errorProcessingFrame: "Fel vid behandling av ram:",
        faceMeshInitError: "Face Mesh-initieringsfel:"
      }
    }
  }
} as const;

export default sv;
